import { fetchApi } from './api';
import { User } from '../types/auth';

interface LoginCredentials {
  email: string;
  password: string;
}

interface RegisterData {
  name: string;
  email: string;
  password: string;
}

export const authService = {
  async login(credentials: LoginCredentials) {
    const response = await fetchApi<User>('/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });
    
    if (response.token) {
      localStorage.setItem('token', response.token);
    }
    
    return response;
  },

  async register(data: RegisterData) {
    const response = await fetchApi<User>('/auth/register', {
      method: 'POST',
      body: JSON.stringify(data),
    });
    
    if (response.token) {
      localStorage.setItem('token', response.token);
    }
    
    return response;
  },

  logout() {
    localStorage.removeItem('token');
  },

  getToken() {
    return localStorage.getItem('token');
  },

  async verifyToken() {
    try {
      const token = this.getToken();
      if (!token) {
        return null;
      }
      
      // Make a request to verify the token
      const response = await fetchApi<User>('/auth/verify', {
        method: 'GET',
      });
      
      return response.data?.user || null;
    } catch (error) {
      // If token verification fails, remove the invalid token
      this.logout();
      return null;
    }
  }
}; 